import api from "@/lib/api";

// Descarcă un fișier de la un endpoint autentificat (cerere din pagină, nu filă nouă): același comportament pe calculator și pe telefon,
// iar o eroare a serverului devine un mesaj, nu o pagină goală.
export async function downloadFile(pathWithQuery, fallbackName = "fisier") {
  try {
    const r = await api.get(pathWithQuery, { responseType: "blob" });
    const cd = r.headers?.["content-disposition"] || "";
    const m = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(cd);
    const name = m ? decodeURIComponent(m[1]) : fallbackName;
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (e) {
    let detail = e?.response?.data?.detail;
    if (!detail && e?.response?.data instanceof Blob) {
      try { detail = JSON.parse(await e.response.data.text())?.detail; } catch { /* răspuns fără detaliu */ }
    }
    throw new Error(detail || "Fișierul nu a putut fi generat");
  }
}

// ?org_unit_id=a&org_unit_id=b&q=...
export function queryString(params) {
  const p = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => (Array.isArray(v) ? v : [v]).forEach(x => { if (x !== "" && x != null) p.append(k, x); }));
  const s = p.toString();
  return s ? `?${s}` : "";
}

// Ca downloadFile, dar cu POST (corp JSON): exporturile care cer parola proprie (GDPR). Numele fișierului vine din antet.
export async function downloadPost(path, body, fallbackName = "fisier") {
  try {
    const r = await api.post(path, body, { responseType: "blob" });
    const cd = r.headers?.["content-disposition"] || "";
    const m = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(cd);
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url; a.download = m ? decodeURIComponent(m[1]) : fallbackName; document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (e) {
    let detail = e?.response?.data?.detail;
    if (!detail && e?.response?.data instanceof Blob) {
      try { detail = JSON.parse(await e.response.data.text())?.detail; } catch { /* răspuns fără detaliu */ }
    }
    throw new Error(detail || "Fișierul nu a putut fi generat");
  }
}
